export enum MaterialPreperationStatus {
    PREPARED = 'Prepared',
    PARTIALLY_CONSUMED = 'Partially Consumed',
    CONSUMED = 'Consumed'
  }